export default "__VITE_ASSET__XJH3N1yv__"